<template>
  <div class="container-fluid">
    <v-card>
      <v-card-text>
        <v-select
          label="Stav platby"
          :items="states"
          v-model="form.paid"
        >
        </v-select>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          text @click="save()"
          :disabled="loading"
        >Uložit</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'OrderPaid',
  props: ['order'],
  data () {
    return {
      loading: false,
      form: {
        paid: this.order.paid
      },
      states: [{ text: 'Zaplacená', value: 1 }, { text: 'Nezaplacená', value: 0 }]
    }
  },
  methods: {
    save () {
      this.loading = true
      this.$http.post(`/admin/orders/${this.order.id}/paid`, this.keysToSnakeCase(this.form))
        .then(() => {
          this.loading = false
          this.$emit('data-saved')
        })
        .catch(err => {
          this.loading = false
          console.log(err)
        })
    }
  }
}
</script>

<style scoped>
.container-fluid{
  padding: 0;
}
</style>
